import { baseApiUrl, fetcher, handleError, ServerErrorResponse } from 'data_sources/constants';
import { GIQAnswers, GIQuestion } from 'views/App/Portal/Policy/_types/giq';

export const answerQuestions = async (
  manualId: string,
  data: GIQAnswers,
  callback?: () => void,
  onError?: (errors: ServerErrorResponse) => void
) => {
  const url = `${baseApiUrl()}/lexiverse/manual-giq/v1/manuals/${manualId}/answers`;
  await fetcher({
    url,
    method: 'put',
    body: data,
  })
    .then(() => {
      if (callback) callback();
    })
    .catch((err) => {
      if (onError) handleError(err, { onError });
    });
};

export const createQuestion = async (
  manualId: string,
  data: GIQuestion,
  callback?: (data: GIQuestion) => void,
  onError?: (errors: ServerErrorResponse) => void
) => {
  const url = `${baseApiUrl()}/lexiverse/manual-giq/v1/manuals/${manualId}/questions`;
  await fetcher({
    url,
    method: 'post',
    body: data,
  })
    .then((data) => {
      if (callback) callback(data);
    })
    .catch((err) => {
      if (onError) handleError(err, { onError });
    });
};

export const updateQuestion = async (
  manualId: string,
  questionId: string,
  data: GIQuestion,
  callback?: (data: GIQuestion) => void,
  onError?: (errors: ServerErrorResponse) => void
) => {
  const url = `${baseApiUrl()}/lexiverse/manual-giq/v1/manuals/${manualId}/questions/${questionId}`;
  await fetcher({
    url,
    method: 'put',
    body: data,
  })
    .then((data) => {
      if (callback) callback(data);
    })
    .catch((err) => {
      console.warn('update err', err);
      if (onError) handleError(err, { onError });
    });
};

export const deleteQuestion = async (
  manualId: string,
  questionId: string,
  callback?: () => void,
  onError?: (errors: ServerErrorResponse) => void
) => {
  const url = `${baseApiUrl()}/lexiverse/manual-giq/v1/manuals/${manualId}/questions/${questionId}`;
  await fetcher({
    url,
    method: 'delete',
    body: {},
  })
    .then(() => {
      if (callback) callback();
    })
    .catch((err) => {
      console.warn('update err', err);
      if (onError) handleError(err, { onError });
    });
};
